import React, { useEffect, useState } from "react";
import { api, formatDateTime } from "../lib/api";
import { PageHeader, LoadingRows, EmptyState } from "../components/common";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Bell, CheckCheck } from "lucide-react";
import { toast } from "sonner";

export default function Notifications() {
  const [items, setItems] = useState([]); const [loading, setLoading] = useState(true);
  const load = async () => {
    const { data } = await api.get("/notifications", { params: { limit: 100 } });
    setItems(data.items); setLoading(false);
  };
  useEffect(() => { load(); }, []);
  const markRead = async (id) => { await api.post(`/notifications/${id}/read`); load(); };
  const readAll = async () => { await api.post("/notifications/read-all"); toast.success("All marked as read"); load(); };
  if (loading) return <LoadingRows rows={6} />;
  return (
    <>
      <PageHeader
        title="Notifications"
        description="Everything the platform wants you to know."
        actions={<Button variant="outline" onClick={readAll} data-testid="notif-read-all"><CheckCheck className="w-4 h-4 mr-1" /> Mark all read</Button>}
      />
      <Card className="rounded-xl divide-y">
        {items.length === 0 ? <div className="p-6"><EmptyState title="No notifications yet" /></div> : items.map((n) => (
          <div key={n.id} className={`p-4 flex gap-3 ${!n.read ? "bg-blue-50/40 dark:bg-blue-950/20" : ""}`}>
            <div className={`w-8 h-8 rounded-lg grid place-items-center shrink-0 ${n.type === "warning" ? "bg-amber-100 text-amber-600" : n.type === "success" ? "bg-emerald-100 text-emerald-600" : "bg-blue-100 text-blue-600"} dark:bg-opacity-30`}>
              <Bell className="w-4 h-4" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-medium text-sm">{n.title}</div>
              <div className="text-sm text-muted-foreground">{n.message}</div>
              <div className="text-xs text-muted-foreground mt-1">{formatDateTime(n.created_at)}</div>
            </div>
            {!n.read && <Button variant="ghost" size="sm" onClick={() => markRead(n.id)} data-testid={`notif-read-${n.id}`}>Mark read</Button>}
          </div>
        ))}
      </Card>
    </>
  );
}
